import Vue from 'vue'
import moment from 'moment'
import {sync} from 'vuex-router-sync'
import SuiVue from 'semantic-ui-vue'
import VueClipboard from 'vue-clipboard2'
import CodeMirror from 'codemirror'
import VueCodemirror from 'vue-codemirror'
import VueSocketio from 'vue-socket.io-extended'
import d2c from './d2c'
import api from './api'
import router from './router'
import store from './store'
import utils from './utils'
import App from './App.vue'
import Flag from './components/Flag'
import Logo from './components/Logo'
import Timer from './components/Timer'
import CopyIcon from './components/CopyIcon'
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';

import 'codemirror/addon/dialog/dialog'
import 'codemirror/addon/scroll/annotatescrollbar'
import 'codemirror/addon/search/searchcursor'
import 'codemirror/addon/search/matchesonscrollbar'
import 'codemirror/addon/search/search'
import 'codemirror/mode/meta'
import 'codemirror/mode/go/go'
import 'codemirror/mode/haxe/haxe'
import 'codemirror/mode/htmlmixed/htmlmixed'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/mode/nginx/nginx'
import 'codemirror/mode/php/php'
import 'codemirror/mode/properties/properties'
import 'codemirror/mode/pug/pug'
import 'codemirror/mode/python/python'
import 'codemirror/mode/ruby/ruby'
import 'codemirror/mode/shell/shell'
import 'codemirror/mode/sql/sql'
import 'codemirror/mode/toml/toml'
import 'codemirror/mode/yaml/yaml'
import '@/vendor/codemirror-mode-apache'

import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/matchesonscrollbar.css'
import 'semantic-ui-css/semantic.css'
import 'flag-icon-css/css/flag-icon.css'
import 'xterm/css/xterm.css'
import './main.css'

Vue.config.perfomance = process.env.NODE_ENV !== 'production'
Vue.config.productionTip = false

// Sentry.init({
//   dsn: 'https://taoken@sentry/2',
//   integrations: [new Integrations.Vue({Vue, attachProps: true})],
// });

CodeMirror.modeInfo.unshift(
  {mode: 'nginx', file: /(default|static)\.conf$/i},
  {mode: 'hxml', file: /memcached\.conf$/i},
  {mode: 'pug', file: /redis\.conf$/i},
  {mode: 'apache', file: /vhost\.conf$/i},
  {mode: 'apache', file: /\.htaccess$/i},
  {mode: 'properties', file: /.*\.env.*/i},
  {mode: 'properties', ext: ['cnf', 'conf']},
)

Vue.use(SuiVue)
Vue.use(VueClipboard)
Vue.use(VueCodemirror)
Vue.use(VueSocketio, api.socket, {store})

Vue.prototype.$modals = {}

Vue.prototype.momentFromNow = date => moment(date).fromNow()
Vue.prototype.momentCalendar = date => moment(date).calendar()
Vue.prototype.momentFormat = (date, format) => moment(date).format(format)
Vue.prototype.pluralize = utils.pluralize
Vue.prototype.prettyBytes = utils.prettyBytes
Vue.prototype.prettyCron = utils.prettyCron

Vue.directive('autoselect', { inserted(el, binding) { if (binding.value) el.querySelector('input').select() } })
Vue.directive('autofocus', { inserted(el) { el.querySelector('input').focus() } })

Vue.component('CopyIcon', CopyIcon)
Vue.component('Flag', Flag)
Vue.component('Logo', Logo)
Vue.component('Timer', Timer)

sync(store, router)

window.name = 'd2c-panel'
window.d2c = d2c

d2c.app = new Vue({router, store, render: h => h(App)}).$mount('#app')
